export const CHANNEL_TYPES = {
  CHAT: 'chat',
  EMAIL: 'email',
  SMS: 'sms',
} as const

export const MESSAGE_TYPES = {
  INIT: 'INIT',
  NEW_CONVERSATION: 'NEW_CONVERSATION',
  GET_CONVERSATION: 'GET_CONVERSATION',
  GET_CONVERSATIONS: 'GET_CONVERSATIONS',
  UPDATE_CONVERSATION: 'UPDATE_CONVERSATION',
  GET_MESSAGES: 'GET_MESSAGES',
  SEND_MESSAGE: 'SEND_MESSAGE',
  MESSAGE: 'MESSAGE',
  SUBSCRIBE_CONVERSATION: 'SUBSCRIBE_CONVERSATION',
  UNSUBSCRIBE_CONVERSATION: 'UNSUBSCRIBE_CONVERSATION',
  SUBSCRIBE_USER: 'SUBSCRIBE_USER',
  UNSUBSCRIBE_USER: 'UNSUBSCRIBE_USER',
  HEARTBEAT: 'HEARTBEAT',
  TYPING_START: 'TYPING_START',
  TYPING_STOP: 'TYPING_STOP',
  REOPEN_CASE: 'REOPEN_CASE',
  UPDATE_CONVERSATION_READ_INDEX: 'UPDATE_CONVERSATION_READ_INDEX',
  GET_FAQ: 'GET_FAQ',
  GET_LAST_MESSAGE: 'GET_LAST_MESSAGE',
} as const

export const CONTENT_TYPES = {
  TEXT: 'text',
  MAIN_CAROUSEL: 'main_carousel',
  WO_CAROUSEL: 'work_orders_carousel',
  LIST: 'list',
  QUICK_REPLY: 'quick_reply',
  IMAGE: 'image',
  AGENT_ASSIGNED: 'agent-assigned',
  REDIRECT_LINK: 'redirect_link',
  FAQ_CARD: 'faq_card',
  WORK_ORDER_CARD: 'work-order-card',
  PROPERTY_CARD: 'property-card',
  TICKET_FORM: 'ticket_form',
} as const

export const AUTHOR_TYPES = {
  BUSINESS: 'business',
  USER: 'user',
} as const

export const DIRECTION = {
  LEFT: 'left',
  RIGHT: 'right',
} as const

export const USER_TYPES = {
  OWNER: 'owner',
  RENTER: 'renter',
  VENDOR: 'vendor',
} as const

export const TIME_DURATION = {
  FIFTEEN_SECONDS: 15,
  THIRTY_SECONDS: 30,
  FIVE_MINUTES: 300,
  THIRTY_MINUTES: 1800, // dialogflow session timeout time
}

export const CONVERSATION_STATE = {
  NEW: 'NEW',
  OPEN: 'OPEN',
  CLOSED: 'CLOSED',
}

export const DEFAULT_SEND_TO = {
  poplar: true,
  owner: false,
  vendor: false,
  renter: false,
}

export const DEFAULT_INTRO_MESSAGE = 'Initializing a session for you...'
export const EXPIRE_INTRO_MESSAGE =
  'Your previous session has expired.\nInitializing a session for you...'
export const SCROLL_TARGET_ID = 'maintenance-messages-bottom'
export const TIME_FORMAT = 'hh:mm a'
export const MAX_CHAT_BUBBLE_LINES = 4
export const DEFAULT_HEARTBEAT_INTERVAL = 60000
export const DEFAULT_FAQ_ICON_URL =
  'https://static-assets.onerent.co/img/messages/img-cover-faq.jpg'
export const POPPYBOT_AVATAR =
  'https://static-assets.onerent.co/img/avatar/avatar4.png'
export const DEFAULT_PROPERTY_ICON_URL =
  'https://static-assets.onerent.co/img/owner-dashboard/img-holder-property.svg'

export const DRAFTS_KEY = 'pmui-drafts'

export const DEFAULT_DEBOUNCE_TIMEOUT = 400

export default {
  CHANNEL_TYPES,
  MESSAGE_TYPES,
  CONTENT_TYPES,
  AUTHOR_TYPES,
  USER_TYPES,
  TIME_DURATION,
  CONVERSATION_STATE,
  DEFAULT_INTRO_MESSAGE,
  EXPIRE_INTRO_MESSAGE,
  SCROLL_TARGET_ID,
  TIME_FORMAT,
  MAX_CHAT_BUBBLE_LINES,
  DEFAULT_HEARTBEAT_INTERVAL,
  DEFAULT_FAQ_ICON_URL,
  DRAFTS_KEY,
  DEFAULT_DEBOUNCE_TIMEOUT,
}
